module.exports = function _of(x) { return [x]; };



//////////////////
// WEBPACK FOOTER
// ./~/ramda/src/internal/_of.js
// module id = MB6y
// module chunks = 78